/* Somnia | carrusel horizontal con peek, compartido por See it styled y Reseñas (antes vivía dentro de
   sections/see-it-styled.liquid). Sin librerías.

   Marcado:
     [data-somnia-carousel]  raíz; opciones en atributos:
        data-carousel-mobile-only  solo en móvil (max-width: 768px); en escritorio no hace nada
        data-carousel-loop         loop infinito con clones (desde 2 slides)
        data-carousel-autoplay     segundos entre pasos (sin atributo o 0 = apagado)
        data-carousel-align        "center" (primera slide centrada) o "start"
     [data-carousel-track]   contenedor con scroll horizontal (tabindex="0": flechas del teclado)
     [data-carousel-item]    cada slide
     [data-carousel-prev] / [data-carousel-next]   botones reales (opcionales)

   Sin loop, la flecha del extremo recibe .is-hidden y aria-disabled; si todo cabe, la raíz recibe .is-static.
   Arrastre con mouse, prefers-reduced-motion y recarga en el editor del tema (shopify:section:load). */
(function () {
  'use strict';
  if (window.SomniaCarousel) return;

  function Carousel(root) {
    this.root = root;
    this.track = root.querySelector('[data-carousel-track]');
    if (!this.track) return;
    this.mobileOnly = root.hasAttribute('data-carousel-mobile-only');
    this.state = null;
    var self = this;
    if (this.mobileOnly) {
      this.mq = window.matchMedia('(max-width: 768px)');
      this.onMq = function () { if (self.mq.matches) self.init(); else self.destroy(); };
      this.onMq();
      if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq); else this.mq.addListener(this.onMq);
    } else {
      this.init();
    }
  }

  Carousel.prototype.init = function () {
    if (this.state) return;
    var root = this.root, track = this.track;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ac = new AbortController(), signal = ac.signal;
    var reals = Array.prototype.slice.call(track.querySelectorAll('[data-carousel-item]'));
    var realCount = reals.length;
    var loop = root.hasAttribute('data-carousel-loop') && realCount >= 2;
    var center = root.getAttribute('data-carousel-align') === 'center';
    var clones = [];

    // Loop infinito: un set de clones antes y otro después (técnica ligera).
    if (loop) {
      var pre = document.createDocumentFragment(), post = document.createDocumentFragment();
      reals.forEach(function (s) {
        var a = s.cloneNode(true), b = s.cloneNode(true);
        a.setAttribute('aria-hidden', 'true'); b.setAttribute('aria-hidden', 'true');
        pre.appendChild(a); post.appendChild(b); clones.push(a, b);
      });
      track.insertBefore(pre, track.firstChild);
      track.appendChild(post);
    }
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-carousel-item]'));

    function setW() { return loop ? (slides[realCount].offsetLeft - slides[0].offsetLeft) : 0; }
    function centerOn(s) { track.scrollLeft = s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2; }
    function centeredIndex() {
      var c = track.getBoundingClientRect(), mid = c.left + c.width / 2, best = 1e9, idx = 0;
      for (var i = 0; i < slides.length; i++) {
        var r = slides[i].getBoundingClientRect(), d = Math.abs(mid - (r.left + r.width / 2));
        if (d < best) { best = d; idx = i; }
      }
      return idx;
    }

    var prevBtn = root.querySelector('[data-carousel-prev]'), nextBtn = root.querySelector('[data-carousel-next]');

    // Sin loop: la flecha del extremo se apaga; si todo cabe, la raíz queda .is-static.
    function updateArrows() {
      if (loop) return;
      var max = track.scrollWidth - track.clientWidth;
      root.classList.toggle('is-static', max <= 2);
      [[prevBtn, track.scrollLeft <= 2], [nextBtn, track.scrollLeft >= max - 2]].forEach(function (p) {
        if (!p[0]) return;
        p[0].classList.toggle('is-hidden', p[1]);
        p[0].setAttribute('aria-disabled', p[1] ? 'true' : 'false');
      });
    }

    // Posición inicial: primera slide real centrada (con vecinas a los lados) o al inicio.
    requestAnimationFrame(function () {
      if (center || loop) {
        var keep = track.style.scrollSnapType; track.style.scrollSnapType = 'none';
        centerOn(loop ? slides[realCount] : slides[0]);
        track.style.scrollSnapType = keep;
      }
      updateArrows();
    });

    // Normaliza el loop al asentarse (salto invisible de un set).
    var dragging = false, normTimer;
    function scheduleNormalize() { if (!loop) return; clearTimeout(normTimer); normTimer = setTimeout(normalize, 140); }
    function normalize() {
      if (dragging) return;
      var idx = centeredIndex(), sw = setW(), keep = track.style.scrollSnapType;
      if (idx < realCount) { track.style.scrollSnapType = 'none'; track.scrollLeft += sw; track.style.scrollSnapType = keep; }
      else if (idx >= realCount * 2) { track.style.scrollSnapType = 'none'; track.scrollLeft -= sw; track.style.scrollSnapType = keep; }
    }
    track.addEventListener('scroll', scheduleNormalize, { passive: true, signal: signal });

    // Arrastre con mouse: desactiva el snap durante el drag (mandatory pelea con scrollLeft por JS).
    var moved = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.target.closest('button, a')) return;
      dragging = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      track.style.scrollSnapType = 'none'; track.classList.add('is-grabbing');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    }, { signal: signal });
    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX; if (Math.abs(dx) > 5) moved = true;
      track.scrollLeft = startLeft - dx;
    }, { signal: signal });
    function endDrag() { if (!dragging) return; dragging = false; track.classList.remove('is-grabbing'); track.style.scrollSnapType = ''; scheduleNormalize(); }
    track.addEventListener('pointerup', endDrag, { signal: signal });
    track.addEventListener('pointercancel', endDrag, { signal: signal });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, { capture: true, signal: signal });
    track.addEventListener('dragstart', function (e) { e.preventDefault(); }, { signal: signal });

    // Flechas + teclado: un paso = la distancia entre dos slides.
    function step(dir) {
      var pitch = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : 0;
      track.scrollBy({ left: dir * pitch, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { if (prevBtn.getAttribute('aria-disabled') !== 'true') step(-1); }, { signal: signal });
    if (nextBtn) nextBtn.addEventListener('click', function () { if (nextBtn.getAttribute('aria-disabled') !== 'true') step(1); }, { signal: signal });
    track.addEventListener('scroll', updateArrows, { passive: true, signal: signal });
    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    }, { signal: signal });

    // Si cambia el ancho (giro de pantalla, "Ver más" en una tarjeta), se recalculan las flechas.
    var ro = null;
    if (!loop && window.ResizeObserver) { ro = new ResizeObserver(updateArrows); ro.observe(track); }

    var apTimer = null;
    var apSeconds = parseFloat(root.getAttribute('data-carousel-autoplay')) || 0;
    if (apSeconds > 0 && !reduce) {
      apTimer = setInterval(function () { if (document.hidden) return; step(1); }, apSeconds * 1000);
      var stopAP = function () { clearInterval(apTimer); apTimer = null; };
      track.addEventListener('pointerenter', stopAP, { signal: signal });
      track.addEventListener('pointerdown', stopAP, { signal: signal });
      track.addEventListener('focusin', stopAP, { signal: signal });
    }

    this.state = { ac: ac, clones: clones, ro: ro, apTimer: function () { return apTimer; } };
  };

  Carousel.prototype.destroy = function () {
    var state = this.state;
    if (!state) return;
    if (state.apTimer()) clearInterval(state.apTimer());
    if (state.ro) state.ro.disconnect();
    state.ac.abort();
    state.clones.forEach(function (c) { c.remove(); });
    this.track.style.scrollSnapType = '';
    this.track.scrollLeft = 0;
    this.track.classList.remove('is-grabbing');
    this.state = null;
  };

  Carousel.prototype.unmount = function () {
    this.destroy();
    if (this.mq) { if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq); else this.mq.removeListener(this.onMq); }
  };

  function mountAll(scope) {
    (scope || document).querySelectorAll('[data-somnia-carousel]').forEach(function (root) {
      if (!root.somniaCarousel) root.somniaCarousel = new Carousel(root);
    });
  }

  window.SomniaCarousel = { mount: mountAll };
  mountAll(document);

  // Editor del tema: al recargar o quitar una sección.
  document.addEventListener('shopify:section:load', function (e) { mountAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-somnia-carousel]').forEach(function (root) {
      if (root.somniaCarousel) { root.somniaCarousel.unmount(); root.somniaCarousel = null; }
    });
  });
})();
